import React, { useEffect, useState, useMemo } from "react";

import Highcharts from "highcharts";
import m from "../Dashboard/assets/greenTick.png";
import p from "../Dashboard/assets/blueTick.png";
import c from "../Dashboard/assets/blackTick.png";
import e from "../Dashboard/assets/redTick.png"; // ENGLISH
import sc from "../Dashboard/assets/pinkTick.png"; // SCIENCE
import ss from "../Dashboard/assets/orangeTick.png"; // SOCIAL_SCIENCE
import rc from "../Dashboard/assets/blackCross.png";
import rp from "../Dashboard/assets/blueCross.png";
import rm from "../Dashboard/assets/greenCross.png";
import re from "../Dashboard/assets/redCross.png"; // ENGLISH
import rsc from "../Dashboard/assets/pinkCross.png"; // SCIENCE
import rss from "../Dashboard/assets/orangeCross.png"; // SOCIAL_SCIENCE
import um from "../Dashboard/assets/greenUnattempted.png";
import up from "../Dashboard/assets/blueUnattempted.png";
import uc from "../Dashboard/assets/blackUnattempted.png";

import ue from "../Dashboard/assets/redUnattempted.png"; // ENGLISH
import usc from "../Dashboard/assets/pinkUnattempted.png"; // SCIENCE
import uss from "../Dashboard/assets/orangeUnattempted.png"; // SOCIAL_SCIENCE
import subjectConfig from "./subjects.json";

const StudentExamBehaviourChart = ({ data = {}, examDurationInMinutes }) => {
  // const [finalData, setFinalData] = useState([]);
  const [myData1, setMyData1] = useState([]);
  const doneIcons = (sub) => {
    if (sub === "MATHEMATICS") {
      return `url(${m})`;
    }
    if (sub === "CHEMISTRY") {
      return `url(${c})`;
    }
    if (sub === "PHYSICS") {
      return `url(${p})`;
    }
    if (sub === "ENGLISH") {
      return `url(${e})`;
    }
    if (sub === "SCIENCE") {
      return `url(${sc})`;
    }
    if (sub === "SOCIAL_SCIENCE") {
      return `url(${ss})`;
    }
  };
  const crossIcons = (sub) => {
    if (sub === "MATHEMATICS") {
      return `url(${rm})`;
    }
    if (sub === "CHEMISTRY") {
      return `url(${rc})`;
    }
    if (sub === "PHYSICS") {
      return `url(${rp})`;
    }
    if (sub === "ENGLISH") {
      return `url(${re})`;
    }
    if (sub === "SCIENCE") {
      return `url(${rsc})`;
    }
    if (sub === "SOCIAL_SCIENCE") {
      return `url(${rss})`;
    }
  };
  const unAttemptedIcons = (sub) => {
    if (sub === "MATHEMATICS") {
      return `url(${um})`;
    }
    if (sub === "CHEMISTRY") {
      return `url(${uc})`;
    }
    if (sub === "PHYSICS") {
      return `url(${up})`;
    }
    if (sub === "ENGLISH") {
      return `url(${ue})`;
    }
    if (sub === "SCIENCE") {
      return `url(${usc})`;
    }
    if (sub === "SOCIAL_SCIENCE") {
      return `url(${uss})`;
    }
  };
  useEffect(() => {
    const myData = Object.entries(data).map(([k, v]) => ({ name: k, data: v }));
    const myDataValues = myData.map((subject) => {
      subject.data = subject.data.map((question) => {
        if (question.decision === "CORRECT") {
          question.marker = {
            symbol: doneIcons(question.subject),
            width: "12px",
            height: "12px",
          };
        }
        if (question.decision === "WRONG") {
          question.marker = {
            symbol: crossIcons(question.subject),
            width: "12px",
            height: "12px",
          };
        }
        if (question.decision === null) {
          question.marker = {
            symbol: unAttemptedIcons(question.subject),
            width: "12px",
            height: "12px",
          };
        }
        return question;
      });
      return subject;
    });
    setMyData1(myDataValues);
  }, [data]);

  const finalData = useMemo(() => {
    const subjectsData = [];
    myData1.forEach((i) => {
      if (subjectConfig[i.name] && subjectConfig[i.name].color) {
        subjectsData.push({ ...i, ...subjectConfig[i.name].color });
      }
    });
    return subjectsData;
  }, [myData1]);
  // useEffect(() => {
  //   const subjectsData = [];
  //   const mergeSubColors = () => {
  //     myData1.map((i) => {
  //       if (subColors[i.name]) {
  //         subjectsData.push({ ...i, ...subColors[i.name] });
  //       }
  //       setFinalData(subjectsData);
  //     });
  //   };
  //   mergeSubColors();
  // }, [myData1]);

  const metadata = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "scatter",
      zoomType: "xy",
      maxWidth: "1200px",

      scroll: "auto",
      overflow: "auto",
    },
    title: {
      text: "Exam Behaviour",
    },
    subtitle: {
      text: "time spent on each question vs timeline",
    },
    legend: {
      enabled: true,
    },
    plotOptions: {
      scatter: {
        dataLabels: {
          enabled: true,
          formatter: function() {
            return `
        
                  <label style="color:  red;font-weight: 500; font-size:8
                  for="Marks" >${
                    this.point.qNo !== undefined ? this.point.qNo : 0
                  }</label> <br/>              
                `;
          },
        },
        marker: {
          radius: 7,
          symbol: "circle",
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        },
      },
      series: {
        events: {
          legendItemClick: function() {
            const selectedSubject = this.name;

            // 👉 Hide all series except the clicked one
            this.chart.series.forEach((s) => {
              if (s.name === selectedSubject) {
                s.show();
              } else {
                s.hide();
              }
            });

            return false; // Prevent default toggle
          },
        },
      },
    },
    xAxis: {
      title: { text: "Exam Time Line(minutes)" },
      // max: examDurationInMinutes,
    },
    yAxis: {
      title: { text: "Time spent on each question(minutes)" },
    },
    // series: finalData || [],
    series: finalData.map((subject, idx) => ({
      name: subject.name,
      visible: idx === 0,
      data: subject.data.map((d) => ({
        ...d,
        x: d.x,
        y: d.y ?  d.y : 0,
        marker: d.marker,
      })),
    })),
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function(props) {
         const qBehaviour = this.point.qBehaviour || [];
        return `
    
        <table>
        <tr>
          <td>Q.No</td>
          <td>${this.point.qNo}</td>
        </tr>
        <tr>
            <td>subject</td>
            <td>${this.point.subject}</td>
          </tr>
          <tr>
            <td>Timespent</td>
            <td>${this.point.timeSpent}</td>
          </tr>
          <tr>
            <td>status</td>
            <td>${this.point.status}</td>
          </tr>
          <tr>
          <td>Final Decision</td>
          <td>${
            this.point.decision === null ? "un_attempted" : this.point.decision
          }</td>
        </tr><tr>
          <tr>
          <td>Answer marked</td>
          <td>${
            this.point.markedAnswer === "NA" ? "_" : this.point.markedAnswer
          }</td>
        </tr>
        <tr>
        <td>No of times visited</td>
        <td>${qBehaviour.filter((q) => q.type === "DISPLAY").length}
        <br/> 
     
        </td>
       
      </tr>
      <tr>
      <td>Marked Answers for every visiting </td>
      <td>
      ${qBehaviour
        .filter((item) => item.type === "EXIT")
        .map((item) => item.markedAnswer)
        .map((value) => {
          if (value === "NA") {
            return "_";
          } else {
            return value;
          }
        })
        .join(",")}
      </td>
      </tr>
        <tr>
        <td>last action</td>
        <td>${
          this.point.type === "DISPLAY"
            ? "You entered the question"
            : this.point.type === "EXIT"
            ? "You exicted the question"
            : "You altered the answer"
        }</td>
      </tr>

        </table>
       
       `;
      },
      valueDecimals: 2,
    },
  };

  const chartDetails = () =>
    Highcharts.chart("student-behaviour-analysis", metadata);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) chartDetails();
  }, [data]);

  return <div id="student-behaviour-analysis" />;
};

export default StudentExamBehaviourChart;
